import XSLX from "sheetjs-style";
import * as FileSaver from "file-saver";

export const ExportToExcel = (excelData: any, fileName: string) => {
    const ws = XSLX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { "data" : ws }, SheetNames: [ "data" ] };
    const excelBuffer = XSLX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "" });
    FileSaver.saveAs(data, fileName + ".xlsx");
};